import { InsideElementMetadata } from "./InsideElementMetadata";

export class ShelfInsideElementMetadata extends InsideElementMetadata {

}
